import Vue from "vue";

import App from "./App.vue";
import store from "./store";

Vue.config.productionTip = false;

const apps = document.querySelectorAll(".t3m-ImageMap");

for (let i = 0; i < apps.length; i++) {
  new Vue({
    store,
    render: h => h(App, { props: { api: apps.item(i).dataset.api } })
  }).$mount(apps[i]);
}
